import { useMemo } from "react";
import { encode } from "uqr";

/** A QR code drawn as one SVG path (uqr, MIT) — the digital receipt the customer scans. */
export function QrCode({
  value,
  label,
  size = 240,
}: {
  value: string;
  label: string;
  size?: number;
}) {
  const path = useMemo(() => {
    const qr = encode(value, { border: 2, ecc: "M" });
    const parts: string[] = [];
    qr.data.forEach((row, y) => {
      row.forEach((dark, x) => {
        if (dark) {
          parts.push(`M${String(x)} ${String(y)}h1v1h-1z`);
        }
      });
    });
    return { d: parts.join(""), size: qr.size };
  }, [value]);
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${String(path.size)} ${String(path.size)}`}
      shapeRendering="crispEdges"
      className="rounded-md bg-white"
    >
      <rect width={path.size} height={path.size} fill="white" />
      <path d={path.d} fill="black" />
    </svg>
  );
}
